<template>
  <modal
    :name="modalName"
    :click-to-close="allowOverlayClose"
    :width="modalWidth"
    height="auto"
    class="modal-custom dynamic-form-modal"
    transition="easeInOut"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <md-card class="modal-header-custom">
      <md-dialog-title>
        <span class="neutral_1 heading-500 text-header-modal">{{ title }}</span>
        <span
          v-if="allowDismiss"
          class="material-icons float-right cursor-pointer"
          @click="dismiss"
        >close</span>
      </md-dialog-title>
    </md-card>
    <md-card-content class="dynamic-form-modal__body">
      <FormSchemaRenderer
        v-if="definition"
        :definition="definition"
        v-model="answers"
      />
      <p v-if="errorMessage" class="text-300-default text-danger mt-10px">{{ errorMessage }}</p>
    </md-card-content>
    <md-dialog-actions class="dynamic-form-modal__actions">
      <button
        v-if="allowDismiss"
        type="button"
        class="btn-stroke md-button text-400-medium"
        :disabled="submitting"
        @click="dismiss"
      >
        {{ dismissLabel }}
      </button>
      <button
        type="button"
        class="btn-active md-button text-400-medium"
        :disabled="submitting"
        @click="submit"
      >
        <vue-element-loading :active="submitting" spinner="bar-fade-scale" />
        {{ submitting ? "Đang gửi..." : submitLabel }}
      </button>
    </md-dialog-actions>
  </modal>
</template>

<script>
import FormSchemaRenderer from "./FormSchemaRenderer.vue";
import FormService from "../../store/services/FormService";
import { markFormDismissedSession } from "../../helper/formPromptSession";

export default {
  name: "DynamicFormModal",
  components: { FormSchemaRenderer },
  props: {
    modalName: { type: String, default: "dynamic-form-modal" },
  },
  data() {
    return {
      form: null,
      definition: null,
      settings: null,
      answers: {},
      submitting: false,
      errorMessage: "",
      isOpen: false,
    };
  },
  computed: {
    title() {
      return (this.definition && this.definition.title) || "Biểu mẫu";
    },
    allowDismiss() {
      return !(this.settings && this.settings.require_submit) && (this.settings ? this.settings.allow_dismiss !== false : true);
    },
    allowOverlayClose() {
      return this.allowDismiss;
    },
    dismissLabel() {
      return (this.settings && this.settings.dismiss_label) || "Để sau";
    },
    submitLabel() {
      return (this.settings && this.settings.submit_label) || "Gửi";
    },
    modalWidth() {
      return this.settings && this.settings.modal_size === "large" ? "720px" : "560px";
    },
  },
  methods: {
    open(formPayload) {
      if (this.isOpen && this.form && formPayload && this.form.id === formPayload.id) {
        return;
      }
      this.form = formPayload;
      this.definition = formPayload.definition || {};
      this.settings = formPayload.settings || {};
      this.answers = {};
      this.errorMessage = "";
      this.$modal.show(this.modalName);
    },
    beforeOpen() {
      this.errorMessage = "";
      this.isOpen = true;
    },
    beforeClose() {
      this.isOpen = false;
    },
    dismiss() {
      if (this.form && this.form.id) {
        markFormDismissedSession(this.form.id);
      }
      this.$modal.hide(this.modalName);
      this.$emit("dismissed", this.form);
    },
    async submit() {
      if (!this.form || !this.form.id) return;
      this.submitting = true;
      this.errorMessage = "";
      try {
        const res = await FormService.submit(
          this.form.id,
          this.answers,
          this.$route && this.$route.fullPath ? this.$route.fullPath : "",
        );
        if (!res || res.status === false) {
          this.errorMessage = (res && res.message) || "Gửi biểu mẫu thất bại";
          return;
        }
        this.$modal.hide(this.modalName);
        this.$emit("submitted", this.form);
        this.$notify({ type: "success", text: "Gửi biểu mẫu thành công" });
      } catch (e) {
        this.errorMessage = "Gửi biểu mẫu thất bại";
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss">
.dynamic-form-modal {
  .dynamic-form-modal__body {
    max-height: 65vh;
    overflow: auto;
    padding: 16px 20px !important;
  }

  .dynamic-form-modal__actions {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 12px 16px !important;

    .md-button {
      min-width: 140px !important;
      width: auto !important;
      padding: 10px 20px !important;
    }
  }

  .text-danger {
    color: #dc2626;
  }
}
</style>
